import { prop, compose, converge, and } from 'ramda';

import { success } from 'app/features/success/selectors';
import { isNewsNotEmpty } from 'app/features/news/selectors';

const latestNewsBlock = compose(prop('latestNewsBlock'), success);
const isVisibleByAccessType = compose(prop('isVisible'), latestNewsBlock);
const isVisible = converge(and, [isVisibleByAccessType, isNewsNotEmpty]);

export { isVisible };
